export default "__VITE_ASSET__07b219c6__"